var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "grid-view" }, [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "div",
            { attrs: { slot: "operations" }, slot: "operations" },
            [
              _c(
                "el-form",
                { attrs: { inline: "", "label-width": "100px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessNo") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.form.jobNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "jobNo", $$v)
                          },
                          expression: "form.jobNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Customer") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { customer: true },
                          "callback-method-type": "value",
                          "default-value": _vm.form.customerId,
                          "callback-params": { key: "customerId" }
                        },
                        on: { parentCallBack: _vm.getValueFromChild }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Mbl2") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.form.mbl,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "mbl", $$v)
                          },
                          expression: "form.mbl"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.searchClickHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Carrier") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { seaCmp: true, active: true },
                          "callback-method-type": "value",
                          "default-value": _vm.form.carrierId || "",
                          "callback-params": { key: "carrierId" }
                        },
                        on: { parentCallBack: _vm.getValueFromChild }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BusinessType") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          model: {
                            value: _vm.form.lob,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "lob", $$v)
                            },
                            expression: "form.lob"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                              value: ""
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_OceanExport"),
                              value: "SE"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_AirExport"),
                              value: "AE"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_FlightVoyage") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.form.flight,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "flight", $$v)
                          },
                          expression: "form.flight"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.finishedClickHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Completed")))]
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OperationRequirementType")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          model: {
                            value: _vm.form.dropRequirementType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dropRequirementType", $$v)
                            },
                            expression: "form.dropRequirementType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                              value: -1
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Storage"),
                              value: 1
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Transportation"),
                              value: 2
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_CustomsDeclaration"
                              ),
                              value: 3
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Finished") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          model: {
                            value: _vm.form.finishedState,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "finishedState", $$v)
                            },
                            expression: "form.finishedState"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                              value: -1
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Yes"),
                              value: 1
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_No"),
                              value: 0
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_SailingDate") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100px" },
                        attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                        on: { change: _vm.dateChangeHandler },
                        model: {
                          value: _vm.form.etdMin,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "etdMin", $$v)
                          },
                          expression: "form.etdMin"
                        }
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100px" },
                        attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                        on: { change: _vm.dateChangeHandler },
                        model: {
                          value: _vm.form.etdMax,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "etdMax", $$v)
                          },
                          expression: "form.etdMax"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.resetHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Reset")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.searchClickHandler
                }
              })
            ],
            1
          ),
          _c("finished-window", {
            attrs: { visible: _vm.finishedWindowVisible },
            on: {
              "update:visible": function($event) {
                _vm.finishedWindowVisible = $event
              },
              saveCallBack: _vm.saveCallBackHandler
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }